import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { IXhrResponseWrapper } from './IXhrResponseWrapper';

interface IAxiosConfig {
  headers: { [key: string]: any };
}

let ApiUrl: string;
let ApiKey: string;
let ApiVersion: string;
let DoEcho: boolean;

let config = {
  ajaxTimeout: 25000,
};

let axiosConfig: IAxiosConfig = {
  headers: {
    // "Cache-Control": "no-cache, no-store, must-revalidate",
    "Cache-Control": "no-cache",
    // "Content-Type": "application/json",
    // "X-Api-Key": ApiKey,
    // Expires: "0",
    // Pragma: "no-cache",
    // crossDomain: false,
    Accept: "*/*",
  },
};

const getHeaders = async (headers: { [key: string]: any }) => {
  // const token = await AccountAuth.authTokenAsync();
  const combinedHeaders: { [key: string]: any } = {
    ...headers,
    ...axiosConfig.headers,
    // Authorization: `Bearer ${token}`,
  };
  if (ApiKey) {
    combinedHeaders["x-api-key"] = ApiKey;
  }
  const hdrs = {
    headers: {
      ...combinedHeaders,
    },
  };
  return hdrs;
};

// const setConfig = (newConfig: { ajaxTimeout: number }) => {
//   config = newConfig;
// };

const resolveApiPath = (path: string, echo?: boolean) => {
  if (path.indexOf("http") === -1) {
    const url = `${ApiUrl}${ApiVersion}${path}`;
    (echo ?? false) && console.log("resolveApiPath", path, url);
    return url;
  }
  return path;
};

axios.defaults.timeout = config.ajaxTimeout;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

export interface IXhr {
  baseSettings(
    apiUrl: string,
    apiVersion: string,
    apiKey: string,
    echo: boolean
  ): void;
  // baseSettings(apiUrl: string, apiKey: string): void;
  addRequestHeader(headerKey: string, headerValue: any): void;
  removeRequestHeader(headerKey: string): void;
  postAsync(
    path: string,
    data: any,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  putAsync(
    path: string,
    data: any,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  getAsync(
    path: string,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  downloadAsync(
    path: string,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  delAsync(
    path: string,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  deleteAsync(
    path: string,
    data: any,
    headers?: { [key: string]: any }
  ): Promise<IXhrResponseWrapper>;
  requestAsync(
    instanceOptions: AxiosRequestConfig | undefined,
    requestOptions: AxiosRequestConfig
  ): Promise<IXhrResponseWrapper>;
}

export const Xhr: IXhr = {
  baseSettings(
    apiUrl: string,
    apiVersion: string,
    apiKey: string,
    echo: boolean
  ) {
    ApiUrl = apiUrl;
    ApiVersion = apiVersion;
    ApiKey = apiKey;
    DoEcho = echo;
  },
  // baseSettings(apiUrl: string, apiKey: string) {
  //   ApiUrl = apiUrl;
  //   ApiVersion = "";
  //   ApiKey = apiKey;
  //   DoEcho = false;
  // },
  addRequestHeader(headerKey: string, headerValue: any) {
    axiosConfig.headers[headerKey] = headerValue;
  },
  removeRequestHeader(headerKey: string) {
    delete axiosConfig.headers[headerKey];
  },
  async postAsync(path: string, data: any, headers = {}) {
    //, cancelToken = null) {
    let finalResponse: IXhrResponseWrapper;
    const fullPath = resolveApiPath(path, true);
    const hdrs = await getHeaders(headers);
    try {
      const rawResponse = await axios.post(fullPath, data, hdrs); //, cancelToken);
      finalResponse = {
        zeosStatus: "success",
        rawResponse: rawResponse,
      };
    } catch (ex) {
      console.log("catch", ex);
      finalResponse = {
        zeosStatus: "error",
        errorResponse: ex,
      };
    }
    return finalResponse;
  },
  async putAsync(path: string, data: any, headers = {}) {
    let finalResponse: IXhrResponseWrapper;
    const fullPath = resolveApiPath(path, DoEcho);
    const hdrs = await getHeaders(headers);
    try {
      const rawResponse = await axios.put(fullPath, data, hdrs); //, cancelToken);
      finalResponse = {
        zeosStatus: "success",
        rawResponse: rawResponse,
      };
    } catch (ex) {
      console.log("catch", ex);
      finalResponse = {
        zeosStatus: "error",
        errorResponse: ex,
      };
    }
    return finalResponse;
  },
  async getAsync(path: string, headers = {}) {
    let finalResponse: IXhrResponseWrapper;
    const hdrs = await getHeaders(headers);
    try {
      const requestConfig: AxiosRequestConfig = {
        method: "get",
        headers: hdrs.headers,
        url: resolveApiPath(path, DoEcho),
      };
      const rawResponse = await axios(requestConfig);
      finalResponse = {
        zeosStatus: "success",
        rawResponse: rawResponse,
      };
    } catch (error: any) {
      console.log("getAsync catch", error);
      // The response interceptor already rejects with error.response, so `error` is
      // usually the response itself; reading .response again dropped the API's message.
      finalResponse = {
        zeosStatus: "error",
        errorResponse: error?.response ?? error,
      };
    }
    return finalResponse;
  },
  async downloadAsync(path: string, headers = {}) {
    let finalResponse: IXhrResponseWrapper;
    const fullPath = resolveApiPath(path, DoEcho);
    const hdrs = await getHeaders(headers);
    try {
      const requestConfig: AxiosRequestConfig = {
        method: "get",
        headers: hdrs.headers,
        url: fullPath,
        responseType: "blob",
      };
      const rawResponse = await axios(requestConfig);
      finalResponse = {
        zeosStatus: "success",
        rawResponse: rawResponse,
      };
    } catch (ex) {
      console.log("catch", ex);
      finalResponse = {
        zeosStatus: "error",
        errorResponse: ex,
      };
    }
    return finalResponse;
  },
  async deleteAsync(path: string, data: any, headers = {}) {
    let finalResponse: IXhrResponseWrapper;
    const fullPath = resolveApiPath(path, DoEcho);
    const hdrs = await getHeaders(headers);
    try {
      //const rawResponse = await axios.delete(fullPath, data, hdrs);
      const requestConfig: AxiosRequestConfig = {
        method: "delete",
        data: data,
        headers: hdrs.headers,
        url: resolveApiPath(path, DoEcho),
      };
      const rawResponse = await axios(requestConfig);
      finalResponse = {
        zeosStatus: "success",
        rawResponse: rawResponse,
      };
    } catch (ex) {
      console.log("catch", ex);
      finalResponse = {
        zeosStatus: "error",
        errorResponse: ex,
      };
    }
    return finalResponse;
  },
  async delAsync(path: string, headers = {}) {
    return await axios.delete(
      resolveApiPath(path, DoEcho),
      await getHeaders(headers)
    );
  },
  async requestAsync(
    instanceOptions: AxiosRequestConfig | undefined,
    requestOptions: AxiosRequestConfig
  ) {
    const instance = axios.create(instanceOptions);
    return await instance.request(requestOptions);
  },
};
